(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('HospitalizationDischargeTo', HospitalizationDischargeTo);

    HospitalizationDischargeTo.$inject = ['$resource'];

    function HospitalizationDischargeTo ($resource) {
        var resourceUrl =  'api/hospitalization-discharge-tos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
